// C14 · بيانات الشركة والحساب (company data & account) i18n namespace.
// Arabic-first (Egyptian) + English parity. Loaded by i18n.ts's require.context.
module.exports = {
  ar: {
    company: {
      title: 'بيانات الشركة والحساب',
      crumbSettings: 'الإعدادات',
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل بيانات الشركة',
      search: '🔎 بحث سريع',
      profile: {
        title: 'الملف التعريفي للشركة',
        save: 'حفظ التعديلات',
        savedTitle: 'تم الحفظ',
        savedMsg: 'تم تحديث بيانات الشركة بنجاح.',
        errorTitle: 'خطأ',
        errorMsg: 'حدثت مشكلة أثناء حفظ البيانات، حاول مرة أخرى.',
      },
      f: {
        name: 'اسم الشركة',
        code: 'كود الشركة',
        commercialReg: 'السجل التجاري',
        taxId: 'البطاقة الضريبية',
        contactPhone: 'هاتف الشركة المحمول',
        contactEmail: 'بريد الشركة',
        employeesCount: 'عدد الموظفين',
      },
      ph: {
        name: 'اسم الشركة',
        contactPhone: '01000000000',
        contactEmail: 'hr@company.com',
      },
      users: {
        title: 'مستخدمي الـ HR',
        add: 'إضافة مستخدم',
        loading: 'جارٍ تحميل المستخدمين…',
        retry: 'حاول تاني',
        empty: 'مفيش مستخدمين HR مسجّلين للشركة دي غير حسابك.',
        thName: 'الاسم',
        thEmail: 'البريد',
        thStatus: 'الحالة',
        thLastLogin: 'آخر دخول',
        neverLoggedIn: 'لسه مدخلش',
        status: { active: 'نشط', suspended: 'موقوف' },
        whatTitle: 'مستخدمي HR دول مين؟ ',
        whatNote:
          'دول حسابات الدخول على بوابة الشركات — مش موظفين مؤمَّن عليهم، وعلشان كده مش بيظهروا في شاشة «الموظفين» لا هنا ولا عند الأدمن. شاشة الموظفين بتعرض المؤمَّن عليهم (جدول Employee)، أما دول فحسابات مستخدمين (جدول User) مرتبطة بالشركة. تقدر تضيف زميل من هنا، وهيدخل بنفس الإيميل والباسورد اللي تحدده.',
        addTitle: 'إضافة مستخدم HR جديد',
        addBtn: 'حفظ المستخدم',
        saving: 'جارٍ الحفظ…',
        addedTitle: 'تمت الإضافة. ',
        addedMsg: 'المستخدم {email} بقى يقدر يدخل على بوابة الشركات بالباسورد اللي حددته. بلّغه بيه بنفسك — إحنا مش بنبعته في إيميل.',
        f: { name: 'الاسم', email: 'البريد', password: 'كلمة المرور' },
        ph: { name: 'اسم المستخدم', email: 'name@company.com', password: '8 حروف على الأقل' },
        passwordHint: '8 حروف على الأقل، وفيها حرف ورقم.',
        rolesTitle: 'ملاحظة الأدوار. ',
        rolesNote:
          'كل مستخدمي HR لهم نفس الصلاحية على شركتهم. مش بتقدر تغيّر باسورد زميل من هنا — دا بيتم من أدمن شركة التأمين، علشان محدش ياخد حساب حد.',
        errors: {
          emailTaken: 'الإيميل دا مستخدم بالفعل لحساب تاني — جرّب إيميل غيره.',
          roleMissing: 'في مشكلة في إعدادات الأدوار على السيرفر — كلّم الدعم.',
          forbidden: 'مش مسموح لك بإدارة مستخدمي الشركة دي.',
          validation: 'في حقول محتاجة تصحيح — راجع المكتوب بالأحمر.',
          network: 'فيه مشكلة في الشبكة — جرّب تاني.',
          generic: 'تعذّر حفظ المستخدم — جرّب تاني.',
        },
      },
      password: {
        title: 'تغيير كلمة المرور',
        f: { current: 'كلمة المرور الحالية', next: 'كلمة المرور الجديدة', confirm: 'تأكيد الجديدة' },
        ph: '••••••••',
        hint: 'يجب أن تتكون من 8 أحرف على الأقل (و128 كحد أقصى)، وتحتوي على حرف ورقم.',
        submit: 'تغيير كلمة المرور',
        submitting: 'جارٍ التغيير…',
        changedTitle: 'تم التغيير',
        changedMsg: 'تم تغيير كلمة المرور بنجاح.',
        error: 'حدث خطأ أثناء تغيير كلمة المرور، تأكد من كلمة المرور الحالية وحاول مرة أخرى.',
      },
      err: {
        required: 'هذا الحقل مطلوب',
        email: 'صيغة البريد غير صحيحة',
        emailTooLong: 'البريد طويل جدًا (191 حرف كحد أقصى)',
        nameTooShort: 'الاسم لازم حرفين على الأقل',
        nameTooLong: 'الاسم طويل جدًا (120 حرف كحد أقصى)',
        tooShort: 'كلمة المرور لازم 8 حروف على الأقل',
        tooLong: 'كلمة المرور طويلة جدًا (128 حرف كحد أقصى)',
        weak: 'كلمة المرور لازم تحتوي على حرف ورقم',
        mismatch: 'التأكيد غير مطابق لكلمة المرور الجديدة',
      },
      note: {
        title: 'ملاحظة',
        body: 'تفعيل حساب الشركة نفسه يتم من قِبل الأدمن. من هنا يقتصر دور الموارد البشرية على إدارة من يمكنه الدخول إلى البورتال.',
      },
      qa: {
        title: 'أسئلة وأجوبة الشركة (Chatbot)',
        body: 'أضف أسئلة وأجوبة خاصة بشركتك تظهر لموظفيك في روبوت المحادثة، إلى جانب الأسئلة العامة.',
        link: 'إدارة الأسئلة والأجوبة →',
      },
    },
  },
  en: {
    company: {
      title: 'Company Data & Account',
      crumbSettings: 'Settings',
      loading: 'Loading…',
      error: 'Something went wrong while loading the company data',
      search: '🔎 Quick search',
      profile: {
        title: 'Company Profile',
        save: 'Save changes',
        savedTitle: 'Saved',
        savedMsg: 'The company data was updated successfully.',
        errorTitle: 'Error',
        errorMsg: 'Something went wrong while saving, please try again.',
      },
      f: {
        name: 'Company name',
        code: 'Company code',
        commercialReg: 'Commercial registration',
        taxId: 'Tax card',
        contactPhone: 'Company phone',
        contactEmail: 'Company email',
        employeesCount: 'Employees count',
      },
      ph: {
        name: 'Company name',
        contactPhone: '01000000000',
        contactEmail: 'hr@company.com',
      },
      users: {
        title: 'HR users',
        add: 'Add a user',
        loading: 'Loading users…',
        retry: 'Retry',
        empty: 'No HR users are registered for this company besides your own account.',
        thName: 'Name',
        thEmail: 'Email',
        thStatus: 'Status',
        thLastLogin: 'Last sign-in',
        neverLoggedIn: 'Never signed in',
        status: { active: 'Active', suspended: 'Suspended' },
        whatTitle: 'Who are HR users? ',
        whatNote:
          'These are sign-in accounts for the companies portal — not insured employees, which is why they never appear on the Employees screen, here or in the admin portal. That screen lists insured people (the Employee table); these are user accounts (the User table) linked to the company. You can add a colleague here, and they sign in with the email and password you set.',
        addTitle: 'Add a new HR user',
        addBtn: 'Save user',
        saving: 'Saving…',
        addedTitle: 'User added. ',
        addedMsg:
          '{email} can now sign in to the companies portal with the password you set. Pass it on yourself — we do not email it.',
        f: { name: 'Name', email: 'Email', password: 'Password' },
        ph: { name: 'User name', email: 'name@company.com', password: 'At least 8 characters' },
        passwordHint: 'At least 8 characters, including a letter and a digit.',
        rolesTitle: 'About roles. ',
        rolesNote:
          'Every HR user has the same permissions over their own company. You cannot reset a colleague’s password here — that is done by the insurer admin, so nobody can take over someone else’s account.',
        errors: {
          emailTaken: 'That email already belongs to another account — try a different one.',
          roleMissing: 'The server’s role configuration is incomplete — please contact support.',
          forbidden: 'You are not allowed to manage this company’s users.',
          validation: 'Some fields need fixing — check the red text.',
          network: 'Network problem — please try again.',
          generic: 'Could not save the user — please try again.',
        },
      },
      password: {
        title: 'Change Password',
        f: { current: 'Current password', next: 'New password', confirm: 'Confirm new' },
        ph: '••••••••',
        hint: 'At least 8 characters (128 max), including a letter and a digit.',
        submit: 'Change password',
        submitting: 'Changing…',
        changedTitle: 'Changed',
        changedMsg: 'The password was changed successfully.',
        error: 'Something went wrong while changing the password — check your current password and try again.',
      },
      err: {
        required: 'This field is required',
        email: 'Invalid email format',
        emailTooLong: 'The email is too long (191 characters max)',
        nameTooShort: 'The name needs at least 2 characters',
        nameTooLong: 'The name is too long (120 characters max)',
        tooShort: 'The password needs at least 8 characters',
        tooLong: 'The password is too long (128 characters max)',
        weak: 'The password must contain a letter and a digit',
        mismatch: 'Confirmation does not match the new password',
      },
      note: {
        title: 'Note',
        body: 'Activating the company account itself is done by the admin. From here HR only manages who can log in to the portal.',
      },
      qa: {
        title: 'Company Q&A (Chatbot)',
        body: 'Add company-specific questions and answers that show up in the employee chatbot alongside the general ones.',
        link: 'Manage Q&A →',
      },
    },
  },
};
